import { I18n } from "@alife/cn-i18n";
export var $i18n = new I18n();
